import { Component, h, Host, Prop } from '@stencil/core';

@Component({
    tag: 'sew-four-column-grid',
    styleUrl: 'sew-four-column-grid.scss',
    shadow: true,
})
export class SewWsFourColumnGrid {
    @Prop({ reflect: true }) disableDefaultMargin: boolean = false;

    render() {
        const gridClasses = {
            defaultMargin: !this.disableDefaultMargin,
        };

        return (
            <Host class={gridClasses}>
                <div class="grid main-content-container">
                    <slot></slot>
                </div>
            </Host>
        );
    }
}
